var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalwar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4,.cls-5,.cls-6{fill:#fff;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#000;stroke-miterlimit:10;}.cls-1{stroke-width:2px;}.cls-2{fill:none;}.cls-3{stroke-width:1.98px;}.cls-4{stroke-width:0.99px;}.cls-5{stroke-width:1.95px;}.cls-6{stroke-width:1.87px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.58,370.27c-9-2.86-14-15.28-14.91-23.89-1-9.83,1.81-19.79,3.18-29.47,1.67-11.7,2.63-18.42,2.35-27.36-.31-10-1.95-15.85-4.19-26.65-2-9.63-4.52-37.69-6.51-54.79-.33,8.08-1,34.55-2.59,49.27-2.48,23-4.14,24.5-5.1,39.57-1.94,30.77,4.64,30,.22,47.33-3.13,12.27-9.13,23.24-7.3,36.18.38,2.7,1.15,5.83.57,10.44-.9,7.06-3.92,9.24-4.31,16.88-.21,4.14.62,4.64-.23,6.62-2.25,5.28-10.17,6.47-14.19,7.08a43.14,43.14,0,0,1-23.13-3.17c-1.15-4.63-2.74-11.19-4.45-19.08-2.23-10.35-8.17-39.06-12.66-90.36-.93-10.58-.36-5.7-4.4-100.94-1.28-30.15-2.05-47.49,3.86-70.85,4.34-17.18,8.88-31.19,15.32-39.69a164.1,164.1,0,0,0,49.52,6c35.06-1.27,58.92-20.5,70-.83a113.51,113.51,0,0,1,8.06,17.8c9.28,25,6.77,48.73,7.67,81.67,1,35.32.51,38.73-.17,47.71-4.86,64.11-13.54,131.5-21,165.68-2.11,1.71-4.41,4.16-7.59,4.47-16.15,1.62-29.36-2.61-32.38-4.43a71.62,71.62,0,0,1-3.09-18.09c-.56-14.86-.73-21.87-3.53-35.93-.21-1.07-.41-1.92-.61-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.2,324.64c1.14,4.41,2.06,8.78,3.28,13.15.57,2.16,1.2,4.31,1.84,6.46s1.37,4.2,3.1,5.76c-6.28-2.47-9.07-19.25-8.22-25.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,364.78a14.1,14.1,0,0,1-9.2,12.22,141.9,141.9,0,0,0,9.2-12.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.79,323.41c4.37,8.37.29,20.24-8.31,24.14a27.54,27.54,0,0,0,8.31-24.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.78,297.25c.75,10.06-6.54,20.36-16.29,23a36.74,36.74,0,0,0,16.29-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.88,271.31a30.92,30.92,0,0,1-13.51,19.06c4.79-6.23,9.22-12.47,13.51-19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.34,269.34c7.2,3.11,8.29,13.87,16.75,14.94a7.19,7.19,0,0,1-5.93-1c-5.36-3.21-6.62-9.69-10.82-13.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,242.45a88.68,88.68,0,0,1,8.74,11.06l1.93,2.94c1.75,2.68,3.28,6.63,7.11,6.25-5.12,2.1-8.15-4.9-10.71-8.08A87.68,87.68,0,0,1,216,242.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.13,103.7c.13,13.28-.94,26.63-1,39.86a114.47,114.47,0,0,0,7.23,38.8,87.51,87.51,0,0,1-9.23-38.78c.11-13.39,1.54-26.6,3-39.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4,105.7c-2,27.59,3.32,54.92,10.47,81.44,1.94,6.3,3.1,13.76,6.43,19.48a13.1,13.1,0,0,0,4.8,4.75,12.53,12.53,0,0,1-5.25-4.46c-3.88-5.8-5.28-12.83-7.48-19.34-7.93-26.35-13.19-54.38-9-81.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,106.35a316.32,316.32,0,0,0,12.67,87c1.15,4,2.62,8,5.7,11a15.61,15.61,0,0,1-4-4.87c-2.09-3.72-3.24-7.83-4.63-11.83a221.21,221.21,0,0,1-7.42-30.79A208.54,208.54,0,0,1,183,106.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.08,108.42c-1,24.77-2.76,50.7-4.41,75.4-1.79,18.7.78,37.81,9.08,54.77a101.23,101.23,0,0,0,9.65,16.15A91.46,91.46,0,0,1,155.88,239c-13.49-26-11.06-46.37-8.77-74.17,1.37-18.1,3.1-38.38,5-56.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.92,106.33c.85,11.35,1.08,22.71,1.17,34.08-.23,11.38.45,22.6,4.53,33.33-5.58-10.12-6.73-22-6.53-33.32,0-11.37.11-22.74.83-34.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205,108.32a758.91,758.91,0,0,0,2,82.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2,107.1a108.85,108.85,0,0,1-6.63,75.05,153.92,153.92,0,0,0,6.63-75.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,104.42q.92,12.77,1.43,25.55c1,21.13.84,44-11,62.38a68.5,68.5,0,0,1-7.83,10.16c10.64-13.44,16-30,16.9-47s0-34.07.54-51.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.85,106.52A133.29,133.29,0,0,1,244,176c-2.81,8.9-6.49,17.48-8.57,26.57a53.44,53.44,0,0,0-1.49,13.82,49.15,49.15,0,0,1,.53-14c2.54-13.79,8.6-26.62,11.08-40.42a161.44,161.44,0,0,0,1.35-55.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59,105.75c6.36,19,10.22,40.53,2.6,59.78-1.65,4.19-3.66,8.18-5.2,12.38-3.89,10.49-5.74,21.52-7.81,32.54.88-8.92,1.9-17.88,4.2-26.64,1.76-7.69,5.6-14.68,8.07-22.12,5.92-18.18,2.45-37.71-1.86-55.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.11,102.46c10.18,29.54,4.81,61.45-3,90.89,5.14-31.07,10.5-59.54,3-90.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.81,128.2c5.11,33.93-5.12,67.88-16.36,99.59,8.52-32.16,18.74-66,16.36-99.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.69,235.43c-5.07,7.78-7.83,16.5-11,25.14-1.63,4.32-3.24,8.61-5,12.9s-5,8.34-9.41,10a18.29,18.29,0,0,0,5-4.62c2.41-3.1,3.88-8.82,5.25-12.5,4-10.64,7.37-22.41,15.25-30.95Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.72,97.56c5.16,5.17,16.91,4.78,16.91,4.78,12.9-.43-.32,2,31.21,2.24,15.69.13,23.54.2,34.57-.78a259.17,259.17,0,0,0,33.8-5.26c.33-1.86-.06-2.7-.48-3.12s-.93-.49-1.05-1,.63-.91.67-1.75-.9-1.14-1-2.25c0-.61.24-.64.48-1.75.2-1,.39-1.85,0-2.25s-1.48.42-3.46.39c-1.66,0-1.78-.69-3-.48-1.64.28-1.9,1.64-3.16,1.56-1.06-.07-1.13-1-2.31-1.17s-1.28.59-2.88,1-1.6-.19-3.27.1c-1.84.32-1.9,1-3.36,1.07s-1.57-.63-3.07-.58-1.53.64-3.07.87-1.93-.35-3.84-.39c-2.14,0-2,.71-4.23.78s-2.65-.72-5-.48c-1.34.13-1.34.41-2.69.48-1.85.11-2.05-.39-3.84-.39-2,0-2.12.63-4.13.59-1.62,0-1.55-.43-3.17-.49-2.13-.08-2.49.6-4.61.59-1.76,0-1.6-.48-3.56-.59-2.3-.13-2.55.52-5.09.49-1.82,0-1.79-.36-3.84-.39-2.26,0-2.26.38-4,.29-2.48-.11-2.75-.93-5-.88-1.78,0-1.66.56-3.37.59-2.39,0-2.69-1-5.09-1-2,0-2.07.73-3.74.49-2.07-.29-2.27-1.45-3.94-1.36-1.52.08-2,1.1-3.36.78-.85-.21-.75-.65-1.73-1-1.49-.5-2,.42-3.55,0-1.17-.32-1.2-1-2.31-1.07s-1.08.4-2,.39c-1.63,0-2-1.49-3.27-1.37a3.09,3.09,0,0,0-2.21,2.34c-.27,1.15.39,1.5.29,3.42a7.3,7.3,0,0,1-.38,2.14c-.44,1.27-.95,1.55-1,2.34A3,3,0,0,0,153.72,97.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.88,90.54a18.05,18.05,0,0,1,4.61.68c1.68.49,2.29,1,3.84,1.08,1.74.13,1.77-.4,3.36-.3,2.18.14,2.62,1.17,5.09,1.56,1.61.26,1.52-.17,3.17,0,3.78.4,4.66,2.69,7.1,2.25,1.57-.29,1.42-1.27,3.27-1.76s2.66.31,5.57.88a50.06,50.06,0,0,0,8,.29c2.65,0,4,0,5-.1,3.84-.38,4.8-1.2,7-.58a17.52,17.52,0,0,0,3.08.88,12.61,12.61,0,0,0,3.07,0c3.71-.39,3.85-1,6-1.08,2.94-.11,3.18,1.06,6,.78,2.19-.21,2-.88,4.13-1.07,2.89-.25,3.42.93,6.34.59,1.7-.21,1.84-.65,3.56-.69,2,0,2.2.54,3.84.49,2.26-.07,2.34-1.22,5-1.66,2.19-.36,2.39.39,4.61-.09,1.85-.41,1.89-1,3.55-1.17,1.83-.24,2.32.36,4,.19a7.92,7.92,0,0,0,3.65-1.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "158.91 93.1 158.91 94.96 157.85 95.86 157.85 97.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "162.33 93.73 162.33 95.59 161.28 96.49 161.28 97.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "167.1 94.96 167.1 96.82 166.04 97.72 166.04 99.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "171.62 95.23 171.62 97.09 170.57 97.99 170.57 99.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "176.58 95.86 176.58 97.72 175.52 98.62 175.52 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "180.52 97.09 180.52 98.95 179.46 99.85 179.46 101.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "184.94 97.37 184.94 99.22 183.88 100.13 183.88 101.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "241.69 97.09 241.69 98.95 242.75 99.85 242.75 101.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "247.45 96.64 247.45 98.5 248.51 99.4 248.51 100.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "252.7 95.86 252.7 97.72 253.76 98.62 253.76 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "257.75 94.96 257.75 96.82 258.8 97.72 258.8 99.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "261.5 94.28 261.5 96.13 262.56 97.03 262.56 98.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "265.1 93.4 265.1 95.25 266.16 96.16 266.16 97.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 189.26,
    y1: 97.37,
    x2: 188.1,
    y2: 101.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 193.46,
    y1: 97.83,
    x2: 192.31,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 197.88,
    y1: 97.83,
    x2: 196.73,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 201.9,
    y1: 97.83,
    x2: 200.75,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 205.18,
    y1: 98.15,
    x2: 204.99,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 210.02,
    y1: 98.15,
    x2: 209.83,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 214.63,
    y1: 98.15,
    x2: 214.44,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 218.87,
    y1: 98.19,
    x2: 219.71,
    y2: 102.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 223.74,
    y1: 98.19,
    x2: 224.58,
    y2: 102.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 228.44,
    y1: 97.8,
    x2: 229.27,
    y2: 102.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 232.72,
    y1: 97.17,
    x2: 233.55,
    y2: 101.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 236.87,
    y1: 97.33,
    x2: 237.71,
    y2: 101.98
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226.91,415.23a60.33,60.33,0,0,0,25.48.67,61.52,61.52,0,0,0,16.28-5.57c-.39,2.64-.77,6.36-1.17,9a53.28,53.28,0,0,1-13.42,3.84c-12.64,1.63-18.5.93-25.75-.59C227.88,418.72,226.17,416.66,226.91,415.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.43,414.61a50.38,50.38,0,0,1-22.79,4.7,53.72,53.72,0,0,1-15.72-2.88c.86,2.53,1.91,6.12,2.77,8.65a46.27,46.27,0,0,0,12.81,1.63c11.69-.41,16.83-2,23.06-4.66C193.23,418.19,194.38,415.89,193.43,414.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalwar01);
export default __webpack_public_path__ + "static/media/SALWAR-01.1667d417209f2548ac8d1485f36d0ab2.svg";
export { ForwardRef as ReactComponent };